const routes = {
  [`/shared`]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'shared-zap-route' */ 'app/shared-zap/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
